'use client';

import { UserRole } from '@/config/roles';
import { umamiIdentify } from '@/lib/analytics/umami';
import { useEffect } from 'react';

export interface UmamiIdentityProps {
  userId?: number | string;
  role?: number;
  locale?: string;
}

/**
 * Attaches the visitor/member segment to the Umami session.
 *
 * Rendered by the layouts with the server-resolved profile, so Umami can split
 * anonymous visitor journeys from member ones without any extra request.
 */
export default function UmamiIdentity({ userId, role, locale }: UmamiIdentityProps) {
  useEffect(() => {
    // The Umami script loads with `defer`, it may not be ready on first paint.
    let attempts = 0;

    const identify = () => {
      umamiIdentify({
        userId,
        role,
        roleName: role !== undefined ? UserRole[role] : undefined,
        locale,
      });
    };

    const timer = window.setInterval(() => {
      attempts += 1;
      if ((window as unknown as { umami?: unknown }).umami || attempts > 20) {
        window.clearInterval(timer);
        identify();
      }
    }, 250);

    return () => window.clearInterval(timer);
  }, [userId, role, locale]);

  return null;
}
